import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'removeWhitespaces',
})
export class RemoveWhitespacesPipe implements PipeTransform {
  transform(value: any): any {
    if (value === undefined) return 'undefined';

    return value.replace(/\s/g, '');
  }
}
